import { ENV_NAME, NODE_ENV } from 'config/envVariables'

//#region React App environment

export const isDevelopment = () => ENV_NAME === 'development' // local environment

export const isDev = () => ENV_NAME === 'dev'

export const isIntegration = () => ENV_NAME === 'int'

export const isProduction = () => ENV_NAME === 'production'

export const isStaging = () => ENV_NAME === 'staging'

export const isRelease = () => ENV_NAME === 'release'
//#endregion
//#region Node environment
export const isNodeDevelopment = () =>
  NODE_ENV === 'development' || NODE_ENV === 'dev'

export const isNodeIntegration = () => NODE_ENV === 'int'

export const isNodeProduction = () => NODE_ENV === 'production'

export const isNodeStaging = () => NODE_ENV === 'staging'

export const isNodeRelease = () => NODE_ENV === 'release'
//#endregion

export const trackingEnvName = ENV_NAME
